module.exports = __webpack_public_path__ + "img/foot_pic_1.18e000cc.png";